import { useTranslation } from 'next-i18next';
import { FC } from 'react';
import Checkbox from 'src/common/components/Checkbox';
import styles from './SelectAll.module.scss';

export type SelectAllProps = {
  indeterminate?: boolean;
  onChange: (checked: boolean) => void;
  checked: boolean;
};
const SelectAll: FC<SelectAllProps> = ({ indeterminate = false, onChange, checked }) => {
  const [t] = useTranslation('admin-listings');
  return (
    <label className={styles.root}>
      <Checkbox indeterminate={indeterminate} onChange={onChange} checked={checked} />
      {t('landing-page--select-all-on-page')}
    </label>
  );
};

export default SelectAll;
